<template>
    <v-container fluid>
        <template v-if="commission">
            <v-row>
                <!-- Commission Badge -->
                <v-col cols="12" xs="12" sm="12" md="3">
                    <v-card class="fill-height pb-3">
                        <div class="overline pl-3 pt-3">
                            <v-icon small left>mdi-calendar</v-icon>
                            Referência
                        </div>

                        <v-card-text class="text-center">
                            <v-col>
                                <v-list-item class="d-flex justify-center">
                                    <v-list-item-avatar size="50">
                                        <v-icon
                                            class="grey lighten-1 white--text"
                                            >mdi-calendar-month</v-icon
                                        >
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title
                                            class="headline font-weight-light text--darken-2 grey--text"
                                        >
                                            {{ commission.reference }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-col>

                            <v-col>
                                <v-chip
                                    class="ml-3"
                                    color="success"
                                    text-color="white"
                                    v-if="commission.paid"
                                >
                                    <v-avatar left>
                                        <v-icon
                                            >mdi-checkbox-marked-circle</v-icon
                                        >
                                    </v-avatar>
                                    Pago
                                </v-chip>
                                <v-chip
                                    class="ml-3"
                                    color="indigo"
                                    text-color="white"
                                    v-else-if="commission.reviewed"
                                >
                                    <v-avatar left>
                                        <v-icon
                                            >mdi-checkbox-marked-circle</v-icon
                                        >
                                    </v-avatar>
                                    Revisado
                                </v-chip>
                                <v-chip
                                    class="ml-3"
                                    color="indigo"
                                    text-color="white"
                                    v-else-if="commission.confirmed"
                                >
                                    <v-avatar left>
                                        <v-icon
                                            >mdi-checkbox-marked-circle</v-icon
                                        >
                                    </v-avatar>
                                    Aprovado parceiro
                                </v-chip>
                                <v-chip
                                    class="ml-3"
                                    color="green-blue"
                                    text-color="white"
                                    v-else-if="commission.approved"
                                >
                                    <v-avatar left>
                                        <v-icon
                                            >mdi-checkbox-marked-circle</v-icon
                                        >
                                    </v-avatar>
                                    Aprovado
                                </v-chip>
                                <v-chip
                                    color="blue-grey lighten-2"
                                    text-color="white"
                                    v-else-if="commission.is_current_month"
                                    class="ml-3"
                                >
                                    <v-avatar left>
                                        <v-icon>mdi-clock</v-icon>
                                    </v-avatar>
                                    Pendente
                                </v-chip>
                                <v-chip
                                    color="red lighten-2"
                                    text-color="white"
                                    v-else
                                    class="ml-3"
                                >
                                    <v-avatar left>
                                        <v-icon>mdi-close</v-icon>
                                    </v-avatar>
                                    Vencida
                                </v-chip>
                            </v-col>
                        </v-card-text>
                    </v-card>
                </v-col>
                <!-- /Commission Badge -->

                <!-- Category Badge -->
                <v-col cols="12" xs="12" sm="12" md="2">
                    <v-card class="fill-height">
                        <div class="overline pl-3 pt-3">
                            <v-icon small left>mdi-medal</v-icon>
                            Categoria de comissão
                        </div>

                        <v-card-text>
                            <category-badge
                                :category="commission.category"
                                :showCommission="true"
                            />
                        </v-card-text>
                    </v-card>
                </v-col>
                <!-- /Category Badge -->

                <v-col cols="12" xs="12" sm="12" md="4">
                    <v-card class="text-no-wrap" height="100%">
                        <div class="overline pl-3 pt-3 mb-3 text-wrap">
                            <v-icon small left>mdi-currency-usd</v-icon>
                            Valores
                        </div>

                        <v-row>
                            <v-col>
                                <v-row>
                                    <v-col class="text-center">
                                        <div class="mt-4 mb-2">
                                            <h3
                                                class="display-1 green--text font-weight-light"
                                            >
                                                {{
                                                    commission.formattedTotalValue
                                                }}
                                            </h3>
                                            <div
                                                class="blue-grey--text text--darken-2 font-weight-light mt-1 d-flex align-center justify-center"
                                            >
                                                Líquido
                                            </div>
                                            <br />
                                            Imposto:
                                            {{ commission.formattedTaxedValue }}
                                            ( {{ commission.formattedTax }})
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="3">
                    <v-card class="fill-height">
                        <div class="overline pl-3 pt-3" v-if="commission.paid">
                            <v-icon small left>
                                mdi-bank
                            </v-icon>
                            Comissão Paga
                        </div>
                        <div
                            class="overline pl-3 pt-3"
                            v-if="commission.confirmed && !commission.paid"
                        >
                            <v-icon small left>
                                mdi-clock-outline
                            </v-icon>
                            Aguardando Pagamento
                        </div>
                        <div
                            class="overline pl-3 pt-3"
                            v-else-if="!commission.confirmed"
                        >
                            <v-icon small left>
                                mdi-bank
                            </v-icon>
                            Confirmação e Nota Fiscal
                        </div>
                        <v-card-text v-if="commission.paid">
                            <v-row>
                                <v-col>
                                    Comissão paga. O comprovante de pagamento já
                                    está disponível.
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-btn
                                        small
                                        outlined
                                        color="light-green darken-2"
                                        @click="downloadItem()"
                                    >
                                        <v-icon small left>
                                            mdi-file-document-box-check-outline
                                        </v-icon>
                                        Comprovante de Pagamento
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-text
                            v-if="commission.confirmed && !commission.paid"
                        >
                            <v-row>
                                <v-col>
                                    Aguardando pagamento da comissão.
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-text v-else-if="!commission.is_current_month">
                            NF da comissão não emitida. Os valores foram transferidos para o mês seguinte
                        </v-card-text>
                        <v-card-text v-else-if="!commission.confirmed">
                            <v-row>
                                <v-col>
                                    <v-file-input
                                        label="Nota fiscal"
                                        v-model="invoice"
                                        show-size
                                    ></v-file-input>
                                </v-col>
                                <v-col>
                                    <v-checkbox
                                        label="Aprovar valores"
                                        color="indigo"
                                        :value="true"
                                        v-model="confirmed"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row v-if="commission.reproved_details">
                                <v-col>
                                    Nota fiscal rejeitada pelo motivo: {{ commission.reproved_details }}
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="caption">
                                    <v-tooltip top max-width="300">
                                        <template v-slot:activator="{ on }">
                                            <span
                                                v-on="on"
                                                d-inline-block
                                                class="text-truncate font-weight-bold"
                                            >
                                                <v-icon medium left>
                                                    mdi-chat-alert-outline
                                                </v-icon>
                                                Caso veja alguma divergência nos
                                                valores...
                                            </span>
                                        </template>
                                        <span>
                                            Caso veja alguma divergência nos
                                            valores, você deve acionar seu (ua)
                                            gerente contas antes de aprovar e
                                            anexar a Nota Fiscal de Serviço
                                            (NFS-e), pois após a aprovação, não
                                            é possível realizar alterações no
                                            valor de pagamento.
                                        </span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="text-right">
                                    <v-btn
                                        color="success"
                                        :loading="loadingSave"
                                        @click="save"
                                    >
                                        <v-icon left small>mdi-check</v-icon>
                                        {{ $t('form.actions.save') }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                    <PeriodIndex :items="commission.commissionPeriods" />
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6">
                    <ActivationIndex
                        :items="commission.commissionActivations"
                    />
                </v-col>
            </v-row>
            <!-- <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                    <v-card>
                        <v-card-title>Comissões</v-card-title>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Cliente</th>
                                        <th class="text-left">Plano</th>
                                        <th class="text-left">Valor</th>
                                        <th class="text-left">Comissão</th>
                                        <th class="text-left">Pago em</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="item in commission.itemsCommission"
                                        :key="item.id"
                                    >
                                        <td>{{ item.customer.trade_name }}</td>
                                        <td>{{ item.planName }}</td>
                                        <td>
                                            {{ item.formattedBaseValue }}
                                        </td>
                                        <td>{{ item.formattedValue }}</td>
                                        <td>{{ item.paidAt }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="4">
                                            <strong>Total</strong>
                                        </td>
                                        <td>
                                            <strong>{{
                                                $n(
                                                    commission.totalValueCommission,
                                                    'currency',
                                                )
                                            }}</strong>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6">
                    <v-card>
                        <v-card-title>Ativações</v-card-title>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Cliente</th>
                                        <th class="text-left">
                                            Produto/Modulo
                                        </th>
                                        <th class="text-left">Parcela</th>
                                        <th class="text-left">Comissão</th>
                                        <th class="text-left">Pago em</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="item in commission.itemsActivation"
                                        :key="item.id"
                                    >
                                        <td>{{ item.customer.trade_name }}</td>
                                        <td>{{ item.activationItem }}</td>
                                        <td>
                                            {{ item.current_installment }} /
                                            {{ item.activation_installments }}
                                        </td>
                                        <td>
                                            {{ $n(item.value, 'currency') }}
                                        </td>
                                        <td>{{ item.paidAt }}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="4">
                                            <strong>Total</strong>
                                        </td>
                                        <td>
                                            <strong>{{
                                                $n(
                                                    commission.totalValueActivation,
                                                    'currency',
                                                )
                                            }}</strong>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
            </v-row> -->
        </template>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import ActivationIndex from '@/shared/components/commission/ActivationIndex'
import CategoryBadge from '@/shared/components/CategoryBadge'
import Commission from '@/models/Commission'
import PeriodIndex from '@/shared/components/commission/PeriodIndex'

export default {
    props: ['id'],

    data: () => {
        return {
            commission: null,
            confirmed: false,
            invoice: null,
            loadingSave: false,
        }
    },

    components: {
        ActivationIndex,
        CategoryBadge,
        PeriodIndex,
    },

    methods: {
        async getCommission() {
            this.commission = await this.model.find(this.id)
        },

        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })
        },

        async save() {
            if (this.confirmed && !this.invoice) {
                this.$bus.$emit('notify', 'error', 'Nota fiscal obrigatória')
                return
            }
            this.loadingSave = true

            let clone = this.commission.clone()
            clone.confirmed = this.confirmed

            if (this.invoice) {
                clone.invoice = await this.toBase64(this.invoice)
            }

            let res

            try {
                res = await clone.save().catch(() => {})
            } finally {
                this.loadingSave = false
            }

            if (!res) return

            this.$bus.$emit(
                'notify',
                'success',
                'Comissão confirmada com sucesso',
            )

            this.$router.push({
                name: 'commission.index',
            })
        },

        async downloadItem() {
            let res = await this.$http.get(
                `commissions/${this.commission.id}/payment-voucher`,
                {
                    responseType: 'blob',
                },
            )

            if (!res) return

            const url = window.URL.createObjectURL(res.data)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', this.commission.payment_voucher)
            document.body.appendChild(link)
            link.click()
        },
    },

    computed: {
        model() {
            return new Commission()
        },
    },

    created() {
        this.getCommission()
    },
}
</script>

<style></style>
